import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {};
export type VerifyVirtualKeyResponse = {};

export const useVerifyVirtualKeys = createMutation<
  VerifyVirtualKeyResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/cars/verify-virtual-keys`,
      method: 'POST',
    }).catch((err: any) => {
      console.log('error', err);
      throw new Error(err.response.data.errors.join(', '));
    }),
});
